/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function t(n, r, o) {
  return n ? r(n) : o == null ? void 0 : o(n);
}
export {
  t as when
};
